// extracted by mini-css-extract-plugin
export default {"MainCont":"Proofing_MainCont__X8gp0","RightCont":"Proofing_RightCont__SZ5Zs"};